<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-database-import"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Importações de BDGD
        </div>
      </template>
      <v-btn
        id="btn-nova-importacao-bdgd"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push({ name: 'Importações BDGD Adicionar' })"
      >
        <v-icon left size="30px">
          mdi-plus-circle
        </v-icon>
        NOVA IMPORTAÇÃO
      </v-btn>
      <v-text-field
        id="importacoes-bdgd-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mt-4 break-search"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-divider class="mt-10" />
      <v-data-table
        class="importacoes-bdgd-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        no-data-text="Nenhuma importação de BDGD disponível"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.tabelas`]="{ item }">
          {{ item.tabelas | handleTabelasColumnValue}}
        </template>
        <template v-slot:[`item.numero_linhas`]="{ item }">
          {{ item.numero_linhas | parseNumberToIntegerBR }}
        </template>
        <template v-slot:[`item.data_registro`]="{ item }">
          {{ item.data_registro | formatToMonth }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="importacao-bdgd-log-criacao"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="dialogCreationLog = true, dialogCreationLogData = {username: item.usuario, created: item.created}"
          >
            <v-icon medium>
              mdi-table-search
            </v-icon>
          </v-btn>
          <v-btn
            id="importacao-bdgd-deletar"
            v-if="item.status == 'AGUARDANDO' && (userIsAdmin || user.id_hexa === item.usuario_id)"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="openDialogDelete(item.id, `#${item.id}`)"
          >
            <v-icon medium>
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-creation-log
      :dialog.sync="dialogCreationLog"
      :item="dialogCreationLogData"
    />
    <dialog-delete 
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Importação de BDGD #{{dialogDeleteData.id}}</template>
      <template slot="body">Tem certeza que deseja deletar essa importação de BDGD?</template>
    </dialog-delete>
  </v-container>
</template>

<script>
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
import ImportacoesBdgdService from '@/services/ImportacoesBdgdService.js';

export default {
  name: "ImportacoesBdgdDataTable",

  mixins: [powerupsActionsMixins],

  props: {
    items: {
      type: Array,
      required: true,
    }
  },

  components: {
    GeneralStatus: () => import("@/components/general/GeneralStatus.vue"),
		DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
    DialogDelete: () => import('@/components/general/DialogDelete'),
  },

  data() {
    return {
      powerupService: ImportacoesBdgdService,
      powerupEntityName: "Importação BDGD",
      dialogCreationLog: false,
      dialogCreationLogData: {},
      search: "",
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Mês dos dados',
          value: 'data_registro'
        },
        {
          text: 'Versão',
          value: 'versao'
        },
        {
          text: 'Entidade',
          value: 'tabelas'
        },
        {
          text: 'Nº de linhas',
          value: 'numero_linhas'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
    }
  },

  filters: {
    handleTabelasColumnValue (arrayTabelas) {
      let formattedValue = arrayTabelas[0].toUpperCase();
      let lengthArray = arrayTabelas.length;
      formattedValue = lengthArray > 1 ? `${formattedValue} + ${lengthArray - 1}` : formattedValue;
      return formattedValue;
    }
  },

  computed: {
    getTabelasConcat() {
      return this.dialogTabelasData.join(', ').toUpperCase();
    }
  }
}
</script>

<style>
  @media screen and (min-width: 800px) {
    .importacoes-bdgd-table tr td:nth-child(6),
    .importacoes-bdgd-table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }
</style>